// extracted by mini-css-extract-plugin
module.exports = {"qualityControl":"video-quality_qualityControl__iVHaK","qualityButton":"video-quality_qualityButton__2LOPi","menu":"video-quality_menu__2LC1f"};